import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { AIO_DXG_EVENTS } from '../../actionTypes/socketActionTypes';
import type { EventReceived, TopicHandler } from './types';

export const handleAioDxgEvents: TopicHandler = (state, event) => {
    if (event.message?.includes('subscribe')) return null;

    const isFsPatchAndNameChangeErrorsEnabled = featureToggleSelectors.isFsPatchAndNameChangeErrorsEnabled(state);
    const isFsSyncFailureMessagingEnabled = featureToggleSelectors.isFsSyncFailureMessagingEnabled(state);
    return {
        type: AIO_DXG_EVENTS,
        payload: event.data,
        meta: { isFsPatchAndNameChangeErrorsEnabled, isFsSyncFailureMessagingEnabled }
    } as EventReceived;
};
